import type { RouteRecordRaw } from "vue-router";
import SupportPage from "./SupportPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/support",
    name: "support",
    component: SupportPage,
  },
];

export default routes;
